import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import _ from 'lodash';
import { defineMessages } from 'react-intl';
import { loadFavoriteCourses, loadFollowedDiscussions } from '../../../actions/auth';
import Layout from '../../../components/Layout/Layout';
import { isTrial, ssrRequest } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import notAuthorized from '../../not-authorized';
import CourseDetailsDiscussions from './CourseDetailsDiscussions';
import notFound from '../../not-found/index';
import { getCourseBySlug, getCourseTextNotes, getCourseVideoNotes } from '../../../actions/courseDetails';
import { getDiscussions } from '../../../actions/discussions';
var messages = defineMessages({
  coursesTitle: {
    id: "CourseDetailsDiscussions.title",
    defaultMessage: [{
      "type": 0,
      "value": "Discussions - "
    }, {
      "type": 1,
      "value": "name"
    }, {
      "type": 0,
      "value": " - Course"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context) {
    var _this = this;
    var store, params, fetch, formatMessage, courseSlug, _store$getState, auth, res, resText, json, result, middlewareError, _store$getState2, courseDetails, courseId, title, promises;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          store = context.store, params = context.params, fetch = context.fetch, formatMessage = context.intl.formatMessage;
          courseSlug = params.courseSlug;
          _store$getState = store.getState(), auth = _store$getState.auth;
          if (isLoggedIn(auth)) {
            _context6.next = 5;
            break;
          }
          return _context6.abrupt("return", notAuthorized(context));
        case 5:
          if (!isTrial(auth)) {
            _context6.next = 7;
            break;
          }
          return _context6.abrupt("return", notFound(context));
        case 7:
          _context6.next = 9;
          return store.dispatch({
            type: getCourseBySlug(courseSlug).types[0]
          });
        case 9:
          _context6.prev = 9;
          _context6.next = 12;
          return getCourseBySlug(courseSlug).promise(fetch);
        case 12:
          res = _context6.sent;
          _context6.next = 15;
          return res.text();
        case 15:
          resText = _context6.sent;
          json = resText ? JSON.parse(resText) : {};
          if (!(res.status !== 200)) {
            _context6.next = 24;
            break;
          }
          if (![403, 404].includes(res.status)) {
            _context6.next = 20;
            break;
          }
          return _context6.abrupt("return", notFound(context));
        case 20:
          _context6.next = 22;
          return store.dispatch({
            error: json,
            type: getCourseBySlug(courseSlug).types[2]
          });
        case 22:
          _context6.next = 27;
          break;
        case 24:
          result = {
            status: res.status,
            json: json
          };
          _context6.next = 27;
          return store.dispatch({
            result: result,
            type: getCourseBySlug(courseSlug).types[1]
          });
        case 27:
          _context6.next = 36;
          break;
        case 29:
          _context6.prev = 29;
          _context6.t0 = _context6["catch"](9);
          middlewareError = new Error("MIDDLEWARE ERROR: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
          middlewareError.stack = _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.stack;
          console.error(middlewareError);
          _context6.next = 36;
          return store.dispatch({
            error: _context6.t0,
            type: getCourseBySlug(courseSlug).types[2]
          });
        case 36:
          _store$getState2 = store.getState(), courseDetails = _store$getState2.courseDetails;
          courseId = _.get(courseDetails, 'course._id');
          title = formatMessage(messages.coursesTitle, {
            name: _.get(courseDetails, 'course.name', '')
          });
          promises = [];
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", store.dispatch(loadFollowedDiscussions(fetch)));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })));
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", store.dispatch(loadFavoriteCourses(fetch)));
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          })));
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var _res, _resText, _json, _result, _middlewareError;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return store.dispatch({
                    type: getCourseTextNotes(courseId).types[0]
                  });
                case 2:
                  _context3.prev = 2;
                  _context3.next = 5;
                  return getCourseTextNotes(courseId).promise(fetch);
                case 5:
                  _res = _context3.sent;
                  _context3.next = 8;
                  return _res.text();
                case 8:
                  _resText = _context3.sent;
                  _json = _resText ? JSON.parse(_resText) : {};
                  if (!(_res.status !== 200)) {
                    _context3.next = 14;
                    break;
                  }
                  if (![403, 404].includes(_res.status)) {
                    _context3.next = 13;
                    break;
                  }
                  return _context3.abrupt("return", notFound(context));
                case 13:
                  return _context3.abrupt("return", store.dispatch({
                    error: _json,
                    type: getCourseTextNotes(courseId).types[2]
                  }));
                case 14:
                  _result = {
                    status: _res.status,
                    json: _json
                  };
                  return _context3.abrupt("return", store.dispatch({
                    result: _result,
                    type: getCourseTextNotes(courseId).types[1]
                  }));
                case 18:
                  _context3.prev = 18;
                  _context3.t0 = _context3["catch"](2);
                  _middlewareError = new Error("MIDDLEWARE ERROR: ".concat(_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message));
                  _middlewareError.stack = _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.stack;
                  console.error(_middlewareError);
                  return _context3.abrupt("return", store.dispatch({
                    error: _context3.t0,
                    type: getCourseTextNotes(courseId).types[2]
                  }));
                case 24:
                case "end":
                  return _context3.stop();
              }
            }, _callee3, null, [[2, 18]]);
          })));
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var _res2, _resText2, _json2, _result2, _middlewareError2;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return store.dispatch({
                    type: getCourseVideoNotes(courseSlug).types[0]
                  });
                case 2:
                  _context4.prev = 2;
                  _context4.next = 5;
                  return getCourseVideoNotes(courseSlug).promise(fetch);
                case 5:
                  _res2 = _context4.sent;
                  _context4.next = 8;
                  return _res2.text();
                case 8:
                  _resText2 = _context4.sent;
                  _json2 = _resText2 ? JSON.parse(_resText2) : {};
                  if (!(_res2.status !== 200)) {
                    _context4.next = 14;
                    break;
                  }
                  if (![403, 404].includes(_res2.status)) {
                    _context4.next = 13;
                    break;
                  }
                  return _context4.abrupt("return", notFound(context));
                case 13:
                  return _context4.abrupt("return", store.dispatch({
                    error: _json2,
                    type: getCourseVideoNotes(courseSlug).types[2]
                  }));
                case 14:
                  _result2 = {
                    status: _res2.status,
                    json: _json2
                  };
                  return _context4.abrupt("return", store.dispatch({
                    result: _result2,
                    type: getCourseVideoNotes(courseSlug).types[1]
                  }));
                case 18:
                  _context4.prev = 18;
                  _context4.t0 = _context4["catch"](2);
                  _middlewareError2 = new Error("MIDDLEWARE ERROR: ".concat(_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message));
                  _middlewareError2.stack = _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.stack;
                  console.error(_middlewareError2);
                  return _context4.abrupt("return", store.dispatch({
                    error: _context4.t0,
                    type: getCourseVideoNotes(courseSlug).types[2]
                  }));
                case 24:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, null, [[2, 18]]);
          })));
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            var query;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  query = {
                    page: 1,
                    sort: '-createDate',
                    search: '',
                    perPage: 50,
                    courseId: courseSlug
                  };
                  return _context5.abrupt("return", ssrRequest({
                    getAction: getDiscussions.bind(_this, query),
                    fetch: fetch,
                    store: store
                  }));
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          })));
          _context6.next = 47;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 47:
          return _context6.abrupt("return", {
            chunks: ['course-details'],
            title: title,
            component: /*#__PURE__*/_jsx(Layout, {
              context: context
            }, void 0, /*#__PURE__*/_jsx(CourseDetailsDiscussions, {
              data: {},
              title: title
            }))
          });
        case 48:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[9, 29]]);
  }));
  return _action.apply(this, arguments);
}
export default action;